import { lt } from '@mews/framework';
import { EmptyStateProps, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { ReservationContractSignatureStatus } from '@mews-commander/data-access';
import { useContractingTableColumns } from './hooks/useContractingTableColumns';
import { ContractingTableRowData, ContractingTableData } from './types';
import { AddButton } from './components/AddButton';
import { EmptyStateActions } from './components/EmptyStateActions';

const data: ContractingTableData = [
    {
        id: '1',
        name: 'Template 1',
        linkedReservation: 'ffa3003e-3660-4a28-8785-b2c101151a58',
        signatureStatus: ReservationContractSignatureStatus.NotSigned,
        signatureDate: '2025-04-16T16:34:00Z',
        expirationDate: '2026-04-16T16:34:00Z',
    },
    {
        id: '2',
        name: 'Template 2',
        linkedReservation: 'ffa3003e-3660-4a28-8785-b2c101151a58',
        signatureStatus: ReservationContractSignatureStatus.Pending,
        signatureDate: '2025-04-16T16:34:00Z',
        expirationDate: '2026-04-16T16:34:00Z',
    },
    {
        id: '3',
        name: 'Template 3',
        linkedReservation: 'ffa3003e-3660-4a28-8785-b2c101151a58',
        signatureStatus: ReservationContractSignatureStatus.Signed,
        signatureDate: '2025-04-16T16:34:00Z',
        expirationDate: undefined,
    },
];

export const ContractingTable = ({ customerId }: { customerId: string }) => {
    const [tableState, setTableState] = useTableState<ContractingTableRowData>({
        pagination: { show: false },
    });

    const columns = useContractingTableColumns({ customerId });

    const emptyStateProps = {
        primaryText: lt('ContractGuestProfileNoDocumentsFoundPrimaryText'),
        secondaryText: lt('ContractGuestProfilesNoDocumentsFoundSecondaryText'),
        action: <EmptyStateActions />,
        size: 'large',
        pictogram: 'search',
    } satisfies EmptyStateProps;

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <TableHeader
                title={lt('ContractGuestProfileContractingTableTitle')}
                globalSearch
                rightSide={<AddButton />}
            />
            <Table
                fixedFirstColumn
                uniqueRowId="id"
                data={data}
                amountOfRows={data?.length ?? 0}
                emptyState={emptyStateProps}
            />
        </TableProvider>
    );
};
